import React from 'react'
import styled from 'styled-components'

import BodyText from 'LuxKit/Typography/BodyText'
import { Place } from 'tripPlanner/types/common'

const LocationWrapper = styled.div`
  display: flex;
  width: 100%;
`

const Location = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

type Props = {
  startPlace: Place
  endPlace?: Place
}

function StartAndEndLocation({ startPlace, endPlace }: Props) {
  return (
    <LocationWrapper>
      <Location>
        <BodyText variant="medium" weight="bold">
          Pick up location
        </BodyText>
        <BodyText variant="large">{startPlace.name}</BodyText>
      </Location>
      {endPlace && (
        <Location>
          <BodyText variant="medium" weight="bold">
            Drop off location
          </BodyText>
          <BodyText variant="large">{endPlace.name}</BodyText>
        </Location>
      )}
    </LocationWrapper>
  )
}

export default StartAndEndLocation
